import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from './Logo';

const links = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/services', label: 'Services' },
  { to: '/portfolio', label: 'Portfolio' },
  { to: '/contact', label: 'Contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-ink-950/85 backdrop-blur-xl border-b border-white/10 shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8 h-20 md:h-[84px] flex items-center justify-between">
        <Link to="/" className="flex items-center shrink-0">
          <Logo size={42} />
        </Link>

        <nav className="hidden md:flex items-center gap-1.5 lg:gap-2">
          {links.map((l) => {
            const active = pathname === l.to;
            return (
              <Link
                key={l.to}
                to={l.to}
                className={`relative px-4 py-2 text-sm font-semibold rounded-lg transition whitespace-nowrap ${
                  active ? 'text-white font-bold' : 'text-white/70 hover:text-white hover:bg-white/5'
                }`}
              >
                {l.label}
                {active && (
                  <span className="absolute bottom-0 inset-x-3 h-[2.5px] bg-gradient-to-r from-neon-500 to-neon-300 rounded-full shadow-[0_0_8px_rgba(139,92,246,0.8)]" />
                )}
              </Link>
            );
          })}
        </nav>

        <div className="hidden md:flex items-center gap-4 shrink-0">
          <Link
            to="/contact"
            className="btn-primary text-white text-sm font-semibold px-6 py-2.5 rounded-lg whitespace-nowrap shadow-[0_0_20px_rgba(139,92,246,0.4)] hover:shadow-[0_0_30px_rgba(139,92,246,0.7)] transition"
          >
            Get Started
          </Link>
        </div>

        <button
          onClick={() => setOpen(!open)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg bg-white/5 border border-white/10 text-white hover:bg-white/10 transition"
          aria-label="Toggle Menu"
        >
          <i className={`ri-${open ? 'close' : 'menu-3'}-line text-2xl`} />
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-ink-950/95 backdrop-blur-2xl border-t border-white/10 shadow-2xl">
          <div className="px-6 py-4 flex flex-col gap-2">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className={`px-4 py-3 rounded-lg text-sm font-semibold border-b border-white/5 transition ${
                  pathname === l.to ? 'text-neon-300 bg-white/5' : 'text-white/80 hover:text-white'
                }`}
              >
                {l.label}
              </Link>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              className="btn-primary text-white text-sm font-semibold px-5 py-3 rounded-lg text-center mt-3 whitespace-nowrap shadow-lg"
            >
              Get Started
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}